import { render, staticRenderFns } from "./jingjiaxuzhi.vue?vue&type=template&id=2b2a6de4&scoped=true"
import script from "./jingjiaxuzhi.vue?vue&type=script&lang=js"
export * from "./jingjiaxuzhi.vue?vue&type=script&lang=js"
import style0 from "./jingjiaxuzhi.vue?vue&type=style&index=0&id=2b2a6de4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a6de4",
  null
  
)

export default component.exports